import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import sanitizeHTML from 'utils/helpers/editor';
import { formatDate } from 'utils/helpers/formatters';

interface IProps {
  name?: string;
  number?: string;
  content?: string;
  isMassDoc?: boolean;
  isMultilingual?: boolean;
  isCentered?: boolean;
}

const PagePreview: FC<IProps> = ({
  content = '',
  name,
  number,
  isMassDoc,
  isMultilingual,
  isCentered = true,
}: IProps) => {
  const { t } = useTranslation();
  const nowDate = formatDate(new Date(), 'dd.mm.Y hh:ii:ss');
  return (
    <Page className={isCentered ? 'u-center' : ''}>
      <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(content) }} />
      {name && number && (
        <Footer>
          {isMassDoc
            ? t(
                isMultilingual ? 'docWizard.step4.massDocWatermarkText_lang2' : 'docWizard.step4.massDocWatermarkText',
                {
                  nowDate,
                  name,
                }
              )
            : t(isMultilingual ? 'docWizard.step4.docWatermarkText_lang2' : 'docWizard.step4.docWatermarkText', {
                nowDate,
                number,
                name,
              })}
        </Footer>
      )}
    </Page>
  );
};

export default PagePreview;

const Page = styled.div`
  background-color: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.boxShadow};
  border: 1px solid ${props => props.theme.colors.lighter};
  max-width: 820px;
  min-height: calc(100vh - 1rem);
  padding: 4rem 6rem 6rem 6rem;

  &.u-center {
    margin: 1rem auto 0;
  }

  @media ${props => props.theme.breakpoints.md} {
    padding: 1.5rem 2rem 2rem 2rem;
  }

  table:not([cellpadding]) {
    border: 1px solid #000;
    border-collapse: separate;
    border-spacing: 0;

    td,
    th {
      border: 1px solid #000;
      padding: 0.4rem;

      p {
        margin-top: 0;
      }

      > *:last-child {
        margin-bottom: 0;
      }
    }

    td:empty:before,
    th:empty:before {
      content: '';
      opacity: 0;
      pointer-events: none;
      user-select: none;
      display: inline-block;
      min-height: 1em;
    }
  }
`;

const Footer = styled.div`
  font-size: 0.75rem;
  opacity: 0.7;
  margin-top: 2rem;
`;
